import { Box } from '@mui/material';
import { useErrorBoundary } from 'react-error-boundary';
import { useParams } from 'react-router-dom';
import { useEffect, useMemo, useState } from 'react';
import Ghost from '../../views/ghost/Ghost';
import NotFound from '../../pages/not-found/NotFound';
import { Variation as VariationInterface } from '../../interfaces/Variation';
import VariationContentPiecesService from '../../services/variation-content-pieces.service';
import SingleVariation from '../single-variation/SingleVariation';

const Variation = () => {
  const { id } = useParams();
  const { showBoundary } = useErrorBoundary();
  const [variation, setVariation] = useState<VariationInterface | null>(null);
  const [isLoading, setIsLoading] = useState<boolean>(false);

  const validateVariation: boolean = useMemo(() => {
    return (
      Number.isInteger(Number(id)) && Number(id) > 0
    );
  }, [id]);

  useEffect(() => {
    if (!id || !validateVariation) {
      return;
    }

    setIsLoading(true);
    VariationContentPiecesService.getById(Number(id))
      .then((data) => setVariation(data))
      .catch((error: Error) => showBoundary(error))
      .finally(() => setIsLoading(false));
  }, [id, validateVariation, showBoundary]);

  if (false === validateVariation) {
    return <NotFound />;
  }

  return (
    <Box className='container mt-5'>
      {isLoading || null === variation ? (
        <Box className='boxed'>
          <Ghost className='article' />
        </Box>
      ) : (
        <Box className='d-flex flex-column'>
          <SingleVariation variation={variation} />
        </Box>
      )}
    </Box>
  );
};

export default Variation;
